/**
 * Formats a stored country value for display. ISO 3166-1 alpha-2 codes (e.g. US) are
 * expanded with {@link Intl.DisplayNames}; other values are returned as-is.
 */
export function formatRegionCodeForLocale(
  regionCode: string,
  locale: string,
): string {
  const v = regionCode.trim();
  if (!v) return "";
  const upper = v.toUpperCase();
  if (!/^[A-Z]{2}$/.test(upper)) return v;
  try {
    return new Intl.DisplayNames([locale], { type: "region" }).of(upper) ?? v;
  } catch {
    return v;
  }
}
